<template>
	<unauth-layout :hideLoginButton="true">
		<template slot="page-content">

			<div v-if="reason" class="alert alert-info alert-dismissible show" role="alert">
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
				<strong>{{reason}}</strong>
			</div>

			<div class="row" style="text-align:center">
				<button type="button" @click="goHome" class="btn btn-primary">
					<i class="fa fa-arrow-left fa-fw"></i> Back
				</button>
			</div>

		</template>
	</unauth-layout>
</template>

<script>
const logger = require("@/utils/logger");
import router from "@/router";
const auth = require("@/utils/auth");

export default {
  props: ["reason"],
  data() {
    return {};
  },
  methods: {
    goHome: function() {
      auth.logout();
    }
  },
  mounted() {
  }
};
</script>

<style>
.alert,
.row {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/LoginCallback.vue